import { getPromise, postPromise, putPromise } from "./request-promise";

import { DrillData, DrillShiftDetails } from '@app/models/data-collection.model';
import { BehaviorSubject } from 'rxjs';

export interface PaginationMetadata {
	page: number;
	perPage: number;
	totalCount: number;
	totalPages: number;
}

export interface PaginatedResponse<T> {
	data: T[];
	pagination: PaginationMetadata;
}

export const dataCollection$ = new BehaviorSubject<DrillData[]>([]);
export interface DataCollectionQueryState {
	search: string;
	completionStatus: string;
	pageIndex: number;
	pageSize: number;
}
export const domainId$ = new BehaviorSubject<number>(null);
export const loading$ = new BehaviorSubject<boolean>(false);


export function getDrillDataCollectionView(
	domainId: number,
	selectedTimeline: string,
	startDate: string,
	endDate: string,
	subDomainId:number,
	siteId: number,
	fileUpload:boolean = false,
	page: number = 1,
	perPage: number = 30,
	search: string = '',
	completionStatus: string = '',
): Promise<PaginatedResponse<DrillData>> {
	if (domainId) {
		const params = new URLSearchParams();
		params.set('domain_id', String(domainId));
		params.set('file', String(fileUpload));
		params.set('page', String(page || 1));
		params.set('per_page', String(perPage || 30));
		if (selectedTimeline) params.set('selected_timeline', selectedTimeline);
		if (startDate) params.set('start_date', startDate);
		if (endDate) params.set('end_date', endDate);
		if (subDomainId) params.set('subdomain_id', String(subDomainId));
		if (siteId) params.set('site_id', String(siteId));
		if (search) params.set('search', search);
		if (completionStatus) params.set('completion_status', completionStatus);
		return getPromise<PaginatedResponse<DrillData>>(`api/dashboards/get_drill_data_collection_view?${params.toString()}`);
	}
	return Promise.resolve({
		data: [],
		pagination: { page: 1, perPage: perPage || 30, totalCount: 0, totalPages: 0 }
	});
}

export function updateDrillDataCollectionField(datasetId: number, key: string, value: string | number | Date) {
	return putPromise<{ message: string }>(
		`api/dashboards/update_drill_data_collection_field`,
		{ dataset_id: datasetId, key, value },
		(data) => data || null
	);
}

export function uploadFile(file: File) {
  const formData: FormData = new FormData();
  formData.append('file', file, file.name);

  return postPromise<{ message: string }>('/api/dashboards/upload_historical_drill_data_collection', formData);
}

// TODO
export function addDataCollectionField(data: object, domainId:number) {
  return postPromise<{ message: string }, { message: string }>(
	`/api/dashboards/create_drill_data`,
	{ data, domain_id:domainId },
	(data) => data || null
  );
}

export function getDrillShiftDetailsCollectionView(domainId: number, selectedTimeline:string, startDate:string, endDate: string, subDomainId:number,
	siteId: number, ) {
	const params =  `${domainId ? '&domain_id=' + domainId : ''}${selectedTimeline ? '&selected_timeline=' + selectedTimeline : ''}${startDate ? '&start_date=' + startDate : ''}${endDate ? '&end_date=' + endDate : ''}${subDomainId ? '&subdomain_id=' + subDomainId : ''}${siteId ? '&site_id=' + siteId : ''}`
	return getPromise<Record<string, DrillShiftDetails[]>>(`api/dashboards/get_drill_shift_details_collection_view?=${params}`);
}

export function createDrillShiftDetails(drillShiftDetails:DrillShiftDetails) {
	return postPromise(
		'api/dashboards/create_drill_shift_detail',
		drillShiftDetails,
		(data: DrillShiftDetails) => data || null
	);
}

export function updateDrillShiftDetailsCollectionField(drillShiftDetailId: number, key: string, value: string | number | Date) {
	return putPromise<{ data: DrillShiftDetails; message: string }>(
		`api/dashboards/update_drill_shift_detail_collection_field`,
		{ id: drillShiftDetailId, key, value },
		(data) => data || null
	);
}
